import { EtapaService } from "./../../services/etapa.service";
import * as FileSaver from "file-saver";
import { empty, merge, Observable, of, concat } from "rxjs";
import { forkJoin } from "rxjs"; // Importe forkJoin e Observable
import { HttpClient, HttpParams } from "@angular/common/http";
import { ExcelService } from "../../services/excel.service";
import { EMPTY } from "rxjs"; // Adicione este import

import {
  Component,
  HostListener,
  Injectable,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { faSort } from "@fortawesome/free-solid-svg-icons";

import { SortDirection } from "../../components/sortable-th/sortable-th.component";
import { Etapas } from "../../entities/etapas";
import { SafraParaCertificacao } from "../../entities/safrasCertificacao";
import { UnidadeProdutiva } from "../../entities/unidade-produtiva";
import { AppService } from "../../services/app-service";
import { PermissionService } from "../../services/permission-service";
import { Services } from "../../services/service";
import { SpinnerService } from "../../services/spinner.service";
import { Base64ToFile } from "../../utils/base64ToFile";

import { throwError } from "rxjs"; // Importe estes
import { catchError } from "rxjs/operators"; // Importe estes

// ... dentro da sua classe de componente/serviço

import {
  concatMap,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  map,
  startWith,
} from "rxjs/operators";
import { ModalHome } from "../../entities/modal-home";
import { PermissoesService } from "../../services/permissoes.service";
import { Setor } from "../../entities/setor";
import { SetoresHome } from "../../entities/setores-home";
import { PerfilUsuario } from "../../entities/perfil";
import { NavigationEnd, Router, Scroll } from "@angular/router";
import { HeaderService } from "../../services/header.service";
import { AuthService } from "../../services/auth.service";
import { NgbTypeahead, NgbTypeaheadConfig } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { ToastService } from "../../services/toast.service";
import { ToastType } from "../../entities/toast";
import { EtapasEnum } from "src/app/modal/modal-retorno/etapas-enum";
import { DetalharUnidadeProdutiva } from "./../../entities/unidade-produtiva";
import { ReplaceNumberPipe } from "src/app/pipes/replace-number.pipe";

@Component({
  selector: "app-licenciamento-bci",
  templateUrl: "./licenciamento-bci.component.html",
  styleUrls: ["./licenciamento-bci.component.scss"],
})
export class LicenciamentoBciComponent implements OnInit {
  sortIcon = faSort;
  dashboard: UnidadeProdutiva[];
  dashboardAll: UnidadeProdutiva[];
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  currentPageSize = 10;
  unidadeProdutiva = new UnidadeProdutiva();
  safraSelecionada = "";
  base64ToFile = new Base64ToFile();
  etapas: Etapas[] = [];
  nivelEtapa: Etapas[] = [];
  public spinnerVisibility: boolean = false;

  // Variável para controlar a visibilidade do modal
  mostrarModal: boolean = false;
  // Variável para armazenar os dados do item selecionado para o modal
  itemParaModal: any | null = null;

  // Método para abrir o modal
  abrirModalDetalhes(item: any): void {
    this.itemParaModal = item; // Passa o item clicado para a variável
    this.mostrarModal = true; // Define a variável para true para exibir o modal
  }

  fecharMeuModal(): void {
    this.mostrarModal = false; // Esconde o modal
    this.itemParaModal = null; // Limpa os dados do modal (opcional, mas boa prática)
  }

  formatNumberManual(value: number | string): string {
    if (value === null || value === undefined) {
      return "";
    }

    const num =
      typeof value === "string"
        ? parseFloat(value.replace(/\./g, "").replace(",", "."))
        : value;

    if (isNaN(num)) {
      return String(value); // Retorna o valor original se não for um número válido
    }

    // Usar Intl.NumberFormat para formatação de milhar
    // 'pt-BR' especifica o locale para usar o padrão brasileiro (ponto como separador de milhar)
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    }).format(num);
  }

  private toNumber(value: number | string): number {
    if (value === null || value === undefined) {
      return 0;
    }

    const num =
      typeof value === "string"
        ? parseFloat(value.replace(/\./g, "").replace(",", "."))
        : value;

    return isNaN(num) ? 0 : num;
  }

  getAreaConversao(item: UnidadeProdutiva): number {
    const areaConversao = this.toNumber(item && item.areaConversao);

    return areaConversao === 0
      ? this.toNumber(item && item.areaAlgodao)
      : item.areaAlgodao - areaConversao;
  }

  calcularProducaoPluma(item: UnidadeProdutiva): number {
    return this.getAreaConversao(item) * this.toNumber(item && item.produtividadePluma);
  }

  isLicenciadaBCI(item: UnidadeProdutiva): boolean {
    return (
      item.etapaAbrId === EtapasEnum["Certificada ABR / Licenciada BCI"] ||
      item.etapaAbr === "Certificada ABR / Licenciada BCI"
    );
  }

  podeEditarLinha(item: UnidadeProdutiva): boolean {
    return this.verificaEdicao() && !this.isLicenciadaBCI(item);
  }

  exportarGridParaExcel(): void {
  this.showSpinner();
  let paramsAll = this._getSeachParamsAll();
  console.log(paramsAll);

  this.Services.getPagination<UnidadeProdutiva>("Dashboard", paramsAll)
    .pipe(
      // Use finalize para garantir que o spinner esconda, mesmo em caso de erro da API.
      // O finalize é executado quando o Observable (da API) completa ou emite um erro.
      // Ele vai ser executado ANTES do .subscribe() adicionar o hideSpinner().
      // Isso é redundante se você usar o .add() no subscribe, mas é uma boa prática.
      finalize(() => {
        // console.log('API de Dashboard concluída ou com erro. Finalizando...');
      })
    )
    .subscribe(
      ({ data }) => {
        this.dashboardAll = data;

        if (this.dashboardAll && this.dashboardAll.length > 0) {
          console.log(this.dashboardAll);
          const dados = this.dashboardAll.map(item => ({
            "PU/LF Code CÓDIGO DA FAZENDA": item.numeroCertificadoBCI,
            "PU/LF Name NOME DA UNIDADE PRODUTIVA": item.nomeUnidadeProdutiva,
            "State Base": item.uf,
            "LF/PU State Nome associacao": item.nomeAssociacao,
            "Group Name Nome do Grupo (new - Due Diligence)": item.tipo ==='Grupo' ? item.produtorGrupo : "-",
            "LF/PU Owner PROPRIETÁRIO DA FAZENDA": item.tipo ==='Produtor' ? item.produtorGrupo : "-",
            "ABR Responsible RESPONSÁVEL ABR": item.responsaveis && item.responsaveis.length ? item.responsaveis[0] : "",
            "ABR Responsible E-mail E-MAIL RESPONSÁVEL ABR": item.emailsResponsaveis && item.emailsResponsaveis.length ? item.emailsResponsaveis[0] : "",
            "PRIMEIRO NOME RESPONSAVEL BCP": item.firstNameResponsavelBCI ?? "",
            "SOBRENOME RESPONSAVEL BCP": item.lastNameResponsavelBCI ?? "",
            "E-MAIL RESPONSAVEL BCI": item.emailResponsavelBCI ?? "",
            "LF/PU Adress Endereço da Unidade Produtiva": item.endereco,
            "LF/PU City MUNICÍPIO": item.municipio,
            "LF/PU Geolocation (Latitude) (new - traceability)": item.latitude,
            "LF/PU Geolocation (Longitude) (new - traceability)": item.longitude,
            "Area under Cotton Production (ha) ÁREA PLANTADA (ha)": this.formatNumberManual(item.areaAlgodao),
            "Licensed Area (ha) AREA LICENCIADA (ha)": this.formatNumberManual(this.getAreaConversao(item)),
            "Lint yield per hectare (Kg /ha) PRODUTIVIDADE PLUMA (kg/ha)": this.formatNumberManual(item.produtividadePluma),
            "Lint Production (kg) PRODUÇÃO PLUMA (kg)": this.formatNumberManual(this.calcularProducaoPluma(item)),
          }));

          this.excelService.exportToExcel(dados, 'BR_ABR_List');

          // <<-- MOVER O HIDE SPINNER PARA AQUI -->>
          // Isso garante que o spinner só suma DEPOIS que a função de exportação for chamada.
          this.hideSpinner();

        } else {
          console.warn('Nenhum dado na grid para exportar.');
          alert('Não há dados na grid para exportar!');
          this.hideSpinner(); // Também esconde o spinner se não houver dados
        }
      },
      (err) => {
        this.toastService.showToast(ToastType.DANGER, "Error", err);
        this.hideSpinner(); // Esconde o spinner em caso de erro da API
      }
    );
    // Remover o .add() aqui, pois já movemos o hideSpinner() para dentro do subscribe
    // .add(() => {
    //   this.hideSpinner();
    // });
}
  safrasCertificacao$: Observable<SafraParaCertificacao[]>;
  ufs = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MS",
    "MT",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];
  dataGrupoProdutor = [];
  dataMunicipio = [];

  searchText = new Subject();
  results: Observable<string[]>;

  sortField: string;
  sortDirection: SortDirection;

  profileForm = new FormGroup({
    id: new FormControl(""),
    unidadeProdutiva: new FormControl(""),
    uf: new FormControl(""),
    municipio: new FormControl(""),
    tipo: new FormControl(""),
    produtorGrupo: new FormControl(""),
    status: new FormControl(""),
    habilitada: new FormControl(""),
    bci: new FormControl(""),
    safraCertificacao: new FormControl(""),
    etapaAbr: new FormControl(""),
  });

  constructor(
    private Services: Services,
    private etapaServices: EtapaService,
    private appService: AppService,
    private permissionService: PermissionService,
    private spinnerService: SpinnerService,
    private permissoesService: PermissoesService,
    private router: Router,
    private headerService: HeaderService,
    private authService: AuthService,
    private toastService: ToastService,
    private excelService: ExcelService
  ) {}

  ngOnInit() {
    this.carregarRedirecionamento();

    if (this.authService.hasToken()) {
      this.headerService.inicializar();
      this._carregarHome();
    }

    this.Services.getAll("Dashboard/ListaGrupoProdutor").subscribe((x) => {
      this.dataGrupoProdutor = x;
    });

    this.Services.getAll("Dashboard/ListaMunicipios").subscribe((x) => {
      this.dataMunicipio = x;
    });
  }

  private carregarRedirecionamento() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if (!this.authService.hasToken()) {
        return;
      }

      if (event.url === "/") {
        this.headerService.inicializar();
        this._carregarHome();
      }
    });
  }

  private _getSeachParams() {
    let params = new HttpParams();
    let usuarioLogado = JSON.parse(window.localStorage.getItem("usuario"));

    params = params.append("pageNumber", this.page.toString());
    params = params.append("pageSize", this.pageSize.toString());

    params = params.append("Id", this.profileForm.get("id").value.toString());
    params = params.append(
      "NomeUnidadeProdutiva",
      this.profileForm.get("unidadeProdutiva").value.toString()
    );
    //Verifica se perfil é ESTAUAL para listar apenas registros da mesma UF do usuario
    if (this.temPerfil("ESTADUAL")) {
      params = params.append("Uf", this.profileForm.get("uf").value.toString());
    } else {
      params = params.append("Uf", this.profileForm.get("uf").value.toString());
    }

    params = params.append(
      "Municipio",
      this.profileForm.get("municipio").value.toString()
    );
    params = params.append(
      "Tipo",
      this.profileForm.get("tipo").value.toString()
    );
    params = params.append(
      "ProdutorGrupo",
      this.profileForm.get("produtorGrupo").value.toString()
    );
    params = params.append(
      "Habilitada",
      this.profileForm.get("habilitada").value.toString()
    );
    params = params.append(
      "Status",
      this.profileForm.get("status").value.toString()
    );
    params = params.append(
      "ParticipanteBCI",
      this.profileForm.get("bci").value.toString()
    );

    params = params.append(
      "SafraCertificacao",
      this.profileForm.get("safraCertificacao").value.toString()
    );
    params = params.append(
      "EtapaAbrId",
      EtapasEnum["Certificada ABR / Em andamento BCI"].toString()
    );
    params = params.append("CodigoSafra", this.safraSelecionada);
    params = params.append("UsuarioIdLogado", usuarioLogado.UsuarioId);

    if (!!this.sortField && !!this.sortDirection) {
      params = params.append(
        "sortBy",
        `${this.sortField},${this.sortDirection}`
      );
    }

    return params;
  }

  private _getSeachParamsAll() {
    let params = new HttpParams();
    let usuarioLogado = JSON.parse(window.localStorage.getItem("usuario"));

    params = params.append("pageNumber", "1");
    params = params.append("pageSize", this.collectionSize.toString());

    params = params.append("Id", this.profileForm.get("id").value.toString());
    params = params.append(
      "NomeUnidadeProdutiva",
      this.profileForm.get("unidadeProdutiva").value.toString()
    );
    //Verifica se perfil é ESTAUAL para listar apenas registros da mesma UF do usuario
    if (this.temPerfil("ESTADUAL")) {
      params = params.append("Uf", this.profileForm.get("uf").value.toString());
    } else {
      params = params.append("Uf", this.profileForm.get("uf").value.toString());
    }

    params = params.append(
      "Municipio",
      this.profileForm.get("municipio").value.toString()
    );
    params = params.append(
      "Tipo",
      this.profileForm.get("tipo").value.toString()
    );
    params = params.append(
      "ProdutorGrupo",
      this.profileForm.get("produtorGrupo").value.toString()
    );
    params = params.append(
      "Habilitada",
      this.profileForm.get("habilitada").value.toString()
    );
    params = params.append(
      "Status",
      this.profileForm.get("status").value.toString()
    );
    params = params.append(
      "ParticipanteBCI",
      this.profileForm.get("bci").value.toString()
    );

    params = params.append(
      "SafraCertificacao",
      this.profileForm.get("safraCertificacao").value.toString()
    );
    params = params.append(
      "EtapaAbrId",
      EtapasEnum["Certificada ABR / Em andamento BCI"].toString()
    );
    params = params.append("CodigoSafra", this.safraSelecionada);
    params = params.append("UsuarioIdLogado", usuarioLogado.UsuarioId);

    if (!!this.sortField && !!this.sortDirection) {
      params = params.append(
        "sortBy",
        `${this.sortField},${this.sortDirection}`
      );
    }

    return params;
  }

  refreshPage(): void {
    this.showSpinner();
    let params = this._getSeachParams();

    this.Services.getPagination<UnidadeProdutiva>("Dashboard", params)
      .subscribe(
        ({ data, pageNumber, pageSize, totalItems }) => {
          data.forEach((item) => {
            item.areaAlgodaoInput = this.formatAreaInput(item.areaAlgodao);
          });
          this.dashboard = data;
          this.page = pageNumber;
          this.pageSize = pageSize;
          this.collectionSize = totalItems;
          this.currentPageSize = this.dashboard.length;
        },
        (err) => {
          this.toastService.showToast(ToastType.DANGER, "Error", err);
        }
      )
      .add(() => {
        this.hideSpinner();
      });
  }

  private _exportPage(
    type: "status_ups" | "historico",
    format: "csv" | "excel"
  ): void {
    let params = this._getSeachParams();

    const route = `Dashboard/${
      format === "excel" ? "exportarExcel" : "exportarCsv"
    }?type=${type}&`;

    this.spinnerService.show();
    this.Services.getByWithParams(route, params)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        })
      )
      .subscribe((response) => {
        FileSaver.saveAs(
          this.base64ToFile.b64toFile(
            response.fileContents,
            response.fileDownloadName,
            response.contentType
          ),
          response.fileDownloadName
        );
      });
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 1
          ? []
          : this.dataGrupoProdutor.filter(
              (v) =>
                v
                  .toLocaleLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .indexOf(
                    term
                      .toLocaleLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                  ) > -1
            )
      )
    );

  searchMunicipios = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      map((term) =>
        term.length < 1
          ? []
          : this.dataMunicipio
              .filter(
                (v) =>
                  v.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
              )
              .splice(0, 10)
      )
    );

  private _carregarHome() {
    this.__carregarDashboard();
  }

  private __carregarDashboard() {
    this.appService.subscriber$.subscribe((safra) => {
      this.profileForm.get("safraCertificacao").setValue("");

      this.safraSelecionada = safra.toString();

      this._loadSafrasCertificacao();

      this.refreshPage();
    });
    this.buscarEtapas();

    this.buscarNivelEtapas();

    console.log(this.dashboard);
  }

  private _loadSafrasCertificacao() {
    this.safrasCertificacao$ = this.Services.getBy(
      "Dashboard/listaSafrasParaCertificacao",
      this.safraSelecionada
    );
  }

  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  onSubmit() {
    this.refreshPage();
  }

  exportarStatusUpsExcel() {
    this._exportPage("status_ups", "excel");
  }

  exportarStatusUpsCsv() {
    this._exportPage("status_ups", "csv");
  }

  exportarHistoricoCsv() {
    this._exportPage("historico", "csv");
  }

  exportarHistoricoExcel() {
    this._exportPage("historico", "excel");
  }

  buscarEtapas() {
    this.etapaServices.getEtapas().subscribe((x) => {
      this.etapas = x;
    });
  }

  buscarNivelEtapas() {
    this.etapaServices.getNivelEtapas().subscribe((x) => {
      this.nivelEtapa = x;
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode != 0 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  allowDecimalNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
    const caractere = String.fromCharCode(charCode);
    const input = event.target as HTMLInputElement;

    if (charCode === 0) {
      return;
    }

    if (caractere === "," && !input.value.includes(",")) {
      return;
    }

    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  atualizarAreaAlgodao(item: UnidadeProdutiva, value: string): void {
    item.areaAlgodaoInput = value;
    item.areaAlgodao = this.parseNumber(value);
  }

  formatarAreaAlgodao(item: UnidadeProdutiva): void {
    if (item.areaAlgodao === null || item.areaAlgodao === undefined) {
      item.areaAlgodaoInput = "";
      return;
    }

    item.areaAlgodaoInput = this.formatAreaInput(item.areaAlgodao);
  }

  private formatAreaInput(value: number | string): string {
    const numero = this.toNumber(value);

    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    }).format(numero);
  }

  temPerfil(permissao: string) {
    const role = this.permissionService.getPermission();
    return role?.some((x) => x == permissao);
  }

  verificaEdicao() {
    const saf = JSON.parse(window.localStorage.getItem("safraAtual")).id;
    if (this.safraSelecionada != saf) return false;

    return true;

    /*
    if(this.temPerfil("ESTADUAL"))
      return true;
    else
      return false;
    */
  }

  setor(setor: string): SetoresHome {
    if (!SetoresHome[setor]) {
      throw new Error("Setor da home não existe");
    }
    return SetoresHome[setor];
  }

  podeVerSetorPorPerfil(perfil: PerfilUsuario, setor: SetoresHome): boolean {
    const setoresPermitidos: SetoresHome[] =
      this.permissoesService.getPermissoes(perfil, Setor.HOME) as SetoresHome[];

    return setoresPermitidos.some((setorPermitido) => setorPermitido === setor);
  }

  permissaoExportacao() {
    return this.permissionService
      .getPerfisValidos()
      ?.some((perfil) => perfil !== PerfilUsuario.BCI);
  }

  podeVerSetor(setor: SetoresHome) {
    return this.permissionService
      .getPerfisValidos()
      ?.some((perfil) => this.podeVerSetorPorPerfil(perfil, setor));
  }

  modal(modal: string): ModalHome {
    if (!ModalHome[modal]) {
      throw new Error("Modal não existe");
    }
    return ModalHome[modal];
  }

  podeVerModal(modalHome: ModalHome) {
    // Obtém os perfis válidos do usuário
    const perfisUsuario = this.permissionService.getPerfisValidos();

    // Verifica se algum dos perfis tem permissão para acessar o modal especificado
    return perfisUsuario.some((perfil) => {
      const permissoesModal = this.permissoesService.getPermissoes(
        perfil,
        Setor.MODAL_HOME
      );
      return permissoesModal === modalHome;
    });
  }

  reset() {
    this.profileForm = new FormGroup({
      id: new FormControl(""),
      unidadeProdutiva: new FormControl(""),
      uf: new FormControl(""),
      municipio: new FormControl(""),
      tipo: new FormControl(""),
      produtorGrupo: new FormControl(""),
      status: new FormControl(""),
      habilitada: new FormControl(""),
      bci: new FormControl(""),
      safraCertificacao: new FormControl(""),
      etapaAbr: new FormControl(""),
    });
  }

  salvarTodasAsLinhas(): void {
    this.toastService.showToast(
      ToastType.SUCCESS,
      "Success",
      "Dados salvos com sucesso."
    );
    /*
  const salvamentos: Observable<any>[] = [];

    // Verifique se dadosDaGrid está preenchido
    if (!this.dashboard || this.dashboard.length === 0) {
      console.warn('Nenhuma linha para salvar na grid.');
      alert('Não há dados para salvar!');
      return;
    }

    this.dashboard.forEach((col) => {
      // Garanta que salvarLinha sempre retorne um Observable válido
      const salvarObservable = this.salvarLinha(col);
      if (salvarObservable) {
        salvamentos.push(salvarObservable);
      } else {
        console.error(`salvarLinha para o ID ${col.id} não retornou um Observable válido.`);
        // Você pode querer tratar isso, talvez removendo essa linha do processamento
        // ou adicionando um Observable.of(null) para não quebrar o forkJoin.
      }
    });

    if (salvamentos.length === 0) {
      console.log('Nenhuma operação de salvamento válida foi coletada.');

      return;
    }

    forkJoin(salvamentos)
      .subscribe(
        (respostas) => {
          console.log('Todas as linhas foram processadas (salvas ou com erro):', respostas);
          // Verificar se todas foram sucesso ou se houve erros individuais
          const erros = respostas.filter(r => r && r.status === 'error');
          if (erros.length > 0) {
            alert(`Algumas linhas falharam ao salvar: ${erros.map(e => e.id).join(', ')}. Verifique o console.`);
          } else {
            alert('Todas as linhas foram salvas com sucesso!');
          }

        },
        error => {
          // Este 'error' só será disparado se um Observable dentro do forkJoin
          // não tiver um catchError e emitir um erro (interrompendo todo o forkJoin).
          // Com o catchError no salvarLinha, este bloco pode não ser mais atingido.
          console.error('Um erro inesperado interrompeu o salvamento de todas as linhas:', error);
          alert('Ocorreu um erro crítico durante o salvamento. Verifique o console.');
        }
      );

      */
  }

salvarTodasLinhas(): void {
    if (!this.dashboard || this.dashboard.length === 0) {
      this.toastService.showToast(
        ToastType.INFO,
        "Info",
        "Não há linhas para salvar."
      );
      return;
    }

    const linhasEditaveis = this.dashboard.filter((item) => this.podeEditarLinha(item));
    if (linhasEditaveis.length === 0) {
      this.toastService.showToast(
        ToastType.INFO,
        "Info",
        "Não há linhas editáveis para salvar."
      );
      return;
    }

    this.showSpinner();

    // Opcional: Ativar um spinner de carregamento global no início do processo.
    // this.isLoadingGlobal = true;

    const operacoesDeSalvamento: Observable<any>[] = [];
    let linhasSalvas = 0;
    let linhasComErro = 0;

    linhasEditaveis.forEach(item => {
        // Para cada item, criamos um Observable que chama salvarLinha.
        // O `catchError` aqui garante que, se uma linha falhar, o `concat` continue para a próxima.
        const salvarObservable = this.salvarLinha(item).pipe(
            catchError(err => {
                linhasComErro++;
                // A mensagem de erro específica já foi exibida pelo catchError dentro de salvarLinha.
                // Apenas logamos e retornamos um Observable que indica a falha,
                // permitindo que a cadeia do `concat` prossiga.
                console.warn(`Salvamento da linha '${item.nomeUnidadeProdutiva}' (ID: ${item.id}) falhou. Continuando com as próximas.`, err);
                return of({ id: item.id, nome: item.nomeUnidadeProdutiva, status: 'falha', error: err.message || 'Erro desconhecido' });

            })
        );
        operacoesDeSalvamento.push(salvarObservable);
    });

    // Usa 'concat' para executar os Observables de salvamento sequencialmente.
    // Cada Observable só é subscrito depois que o anterior é concluído.
    concat(...operacoesDeSalvamento)
        .pipe(
            // O `finalize` é executado uma vez que TODOS os Observables em 'concat' são concluídos,
            // independentemente de sucesso ou falha.
            finalize(() => {
                // Opcional: Desativar o spinner de carregamento global.
                // this.isLoadingGlobal = false;
                console.log('Todas as operações de salvamento sequenciais concluídas.');
                this.hideSpinner();
                // Você pode adicionar um toast final aqui se quiser uma mensagem geral.
            })
        )
        .subscribe(
            resultadoParcial => {
                // Este 'next' é chamado para CADA resultado individual de cada linha que é salva (ou falha tratada).
                // Você pode usar isso para atualizar o status de cada linha na UI em tempo real, se necessário.
                console.log('Resultado parcial da linha:', resultadoParcial);
                if (resultadoParcial && resultadoParcial.status === 'falha') {
                    // Já exibimos o toast de erro específico da linha, mas você pode querer uma lógica de UI aqui.
                } else {
                    linhasSalvas++;
                    // Linha salva com sucesso (ou vazio se EMPTY foi retornado, que não passa por aqui)
                    // Você pode exibir um toast de sucesso individual AQUI também,
                    // mas seu salvarLinhaIndividual já faz isso, então evite duplicar se não quiser vários toasts.
                }
            },
            error => {
                // Este 'error' só seria chamado se um erro INESPERADO (não capturado pelo catchError individual)
                // interrompesse a cadeia completa do `concat`.
                console.error('Erro fatal que interrompeu o processamento sequencial:', error);
                this.toastService.showToast(ToastType.DANGER, "Erro Crítico", "Ocorreu um erro inesperado e o salvamento foi interrompido.");

            },
            () => {
                // Este 'complete' é chamado SOMENTE quando toda a cadeia de 'concat' foi executada sem erros fatais.
                // Aqui é um bom lugar para uma mensagem de sucesso final, após todas as linhas.
                if (linhasComErro === 0) {
                  this.toastService.showToast(
                    ToastType.SUCCESS,
                    "Sucesso",
                    `${linhasSalvas} linha(s) salva(s) com sucesso.`
                  );
                } else {
                  this.toastService.showToast(
                    ToastType.DANGER,
                    "Atenção",
                    `${linhasSalvas} linha(s) salva(s) e ${linhasComErro} linha(s) com erro.`
                  );
                }
                this.hideSpinner();
            }

        );


}

  salvarLinhaIndividual(item: UnidadeProdutiva): void {
    // Inicia um indicador de carregamento, se tiver (ex: isLoading = true;)
    if (!this.podeEditarLinha(item)) {
      this.toastService.showToast(
        ToastType.INFO,
        "Info",
        "Fazenda bloqueada para edição."
      );
      return;
    }

    this.salvarLinha(item).subscribe({
      next: (res) => {
        // Este bloco 'next' só será executado se TODAS as operações dentro de salvarLinha
        // (incluindo as duas chamadas de API) forem bem-sucedidas e não retornarem EMPTY.
        this.toastService.showToast(
          ToastType.SUCCESS,
          "Success",
          `Linha ${item.nomeUnidadeProdutiva} salva com sucesso.`
        );
        // Opcional: Atualizar o estado da UI para esta linha (ex: desabilitar o botão de salvar, marcar como salva)
      },
      error: (err) => {
        // Este bloco 'error' será executado se alguma validação interna lançar um erro (throwError)
        // ou se uma chamada de API retornar erro HTTP, ou se a validação BCI retornar "Existe_NumeroBCI"
        // e você tiver optado por throwError em vez de EMPTY lá.
        // A mensagem de erro já deve ter sido exibida pelo catchError dentro de salvarLinha,
        // mas você pode logar aqui ou fazer algo mais genérico se necessário.

        console.error('Erro ao salvar linha individualmente:', err);
        // this.toastService.showToast(ToastType.DANGER, "Erro", "Não foi possível salvar a linha.");
      },
      complete: () => {

        // Este bloco 'complete' é executado quando o Observable termina (seja por sucesso, erro ou EMPTY)
        // Opcional: Finalizar um indicador de carregamento para esta linha específica
        // isLoading = false;
        console.log(
          `Operação de salvar para ${item.nomeUnidadeProdutiva} concluída.`
        );
      },
    });
  }

  salvarLinha(item: any): Observable<any> {
    // Note que agora sempre retorna Observable<any>
    if (!this.podeEditarLinha(item)) {
      return of(null);
    }

    if (!item.firstNameResponsavelBCI) {
      this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva + ' - Primeiro nome do responsavel BCP e obrigatorio. Corrija antes de salvar.');
      return throwError(() => new Error('Primeiro nome do responsavel BCP obrigatorio'));
    }

    if (!item.lastNameResponsavelBCI) {
      this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva + ' - Sobrenome do responsavel BCP e obrigatorio. Corrija antes de salvar.');
      return throwError(() => new Error('Sobrenome do responsavel BCP obrigatorio'));
    }
    if (!item.emailResponsavelBCI) {
      this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva + ' - E-mail do responsável BCP é obrigatório. Corrija antes de salvar.');
      return throwError(() => new Error('E-mail do responsável BCP obrigatório'));
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.emailResponsavelBCI)) {
      this.toastService.showToast(ToastType.DANGER, "Error",'Fazenda '+ item.nomeUnidadeProdutiva + ' - E-mail do responsável BCP inválido. Corrija antes de salvar.');
      return throwError(() => new Error('E-mail do responsável BCP inválido'));
    }

    // Validações SÍNCRONAS (antes das chamadas HTTP)
    if (item.areaAlgodao < 1) {
        this.toastService.showToast(ToastType.DANGER, "Error",  item.nomeUnidadeProdutiva  + ' - Área plantada deve ser maior que 0. Corrija antes de salvar.');
        // Retorna um Observable que emite um erro ou simplesmente um Observable vazio
        // throwError é bom se você quiser que o erro seja capturado no subscribe externo
        // of(null) ou EMPTY são bons se você só quer parar o fluxo sem emitir um erro "fatal"
        return throwError(() => new Error('Área plantada inválida')); // Lança um erro para ser capturado no .subscribe()
    }

    if (item.produtividadePluma < 1) {
        this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva  + ' - Produtividade Pluma deve ser maior que 0. Corrija antes de salvar.');
        return throwError(() => new Error('Produtividade Pluma inválida (menor que 1)'));
    }

    if (item.produtividadePluma > 5000) {
        this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva  + ' - O limite da produtividade é de 5.000. Corrija antes de salvar.');
        return throwError(() => new Error('Produtividade Pluma excede o limite'));
    }

    if (item.produtividadePluma < 250) {
        this.toastService.showToast(ToastType.DANGER, "Error", item.nomeUnidadeProdutiva  + ' - Informe uma produtividade superior a 250. Corrija antes de salvar.');
        return throwError(() => new Error('Produtividade Pluma abaixo do mínimo'));
    }


    // Preparação dos parâmetros
    var paramsPluma = {
      CodigoSafra: item.codigoSafra,
      UnidadeProdutivaId: item.id,
      upCertificacaoId: item.upID,
      AreaAlgodao: item.areaAlgodao,
      ProdutividadePluma: item.produtividadePluma,
      ProducaoPluma: this.calcularProducaoPluma(item),
      FirstNameResponsavelBCI: item.firstNameResponsavelBCI,
      LastNameResponsavelBCI: item.lastNameResponsavelBCI,
      EmailResponsavelBCI: item.emailResponsavelBCI,
    };

    var paramsNumeroCertificado = {
      CodigoSafra: item.codigoSafra,
      UnidadeProdutivaId: item.id,
      upCertificacaoId: item.upID,
      numeroCertificadoBCI:
        typeof item.numeroCertificadoBCI === "string"
          ? item.numeroCertificadoBCI.trim() || null
          : item.numeroCertificadoBCI || null,
    };

    console.log(paramsNumeroCertificado);

    // Encadeamento das chamadas de API
    return this.Services.post(
      "UpCertificacao/AtualizaNumeroCertificacaoBCI",
      paramsNumeroCertificado
    ).pipe(
      concatMap((resBCI: any) => {
        // Renomeei para resBCI para clareza
        console.log("Resposta BCI:", resBCI);

        if (resBCI === "Existe_NumeroBCI") {
          this.toastService.showToast(
            ToastType.DANGER,
            "Error",
            "Já existe código de fazenda " +
              paramsNumeroCertificado.numeroCertificadoBCI +
              " cadastrado. Corrija antes de salvar."
          );
          return EMPTY; // Retorna um Observable vazio para parar a cadeia para esta linha
        } else {
          // Se a validação BCI passou, chama a próxima API
          return this.Services.post(
            "UpCertificacao/AlterarLicenciamentoBCIPlumas",
            paramsPluma
          );
        }
      }),
      // Adicione um catchError para tratar erros HTTP ou erros lançados por throwError
      catchError((error) => {
        // Aqui você pode logar o erro ou fazer algo mais específico
        console.error(
          "Erro ao processar linha (API ou validação):",
          item,
          error
        );
        this.toastService.showToast(
          ToastType.DANGER,
          "Error",
          `Erro ao salvar ${item.nomeUnidadeProdutiva}: ${
            error.message || "Erro desconhecido"
          }`
        );
        return throwError(() => new Error(`Falha ao salvar linha ${item.id}`)); // Propaga o erro para ser capturado no salvamento de todas as linhas
      })
    );
  }

  salvarLinha2(item: any): Observable<any> {
    console.log("Item clicado:", item);

    if (item.areaAlgodao < 1) {
      this.toastService.showToast(
        ToastType.DANGER,
        "Error",
        "Área plantada deve ser maior que 0. Corrija antes de salvar."
      );
      return;
    }

    if (item.produtividadePluma < 1) {
      this.toastService.showToast(
        ToastType.DANGER,
        "Error",
        "Produtividade Pluma deve ser maior que 0. Corrija antes de salvar."
      );
      return;
    }

    if (item.produtividadePluma > 5000) {
      this.toastService.showToast(
        ToastType.DANGER,
        "Error",
        "O limite da produtividade é de 5.000. Corrija antes de salvar."
      );

      // Focar no primeiro input com erro (opcional)
      setTimeout(() => {
        const inputComErro = document.querySelector(
          ".border-red"
        ) as HTMLElement;
        if (inputComErro) {
          inputComErro.focus();
        }
      });

      return;
    }

    if (item.produtividadePluma < 250) {
      this.toastService.showToast(
        ToastType.DANGER,
        "Error",
        "Informe uma produtividade superior a 250. Corrija antes de salvar."
      );

      // Focar no primeiro input com erro (opcional)
      setTimeout(() => {
        const inputComErro = document.querySelector(
          ".border-red"
        ) as HTMLElement;
        if (inputComErro) {
          inputComErro.focus();
        }
      });

      return;
    }

    var paramsPluma = {
      CodigoSafra: item.codigoSafra,
      UnidadeProdutivaId: item.id,
      AreaAlgodao: item.areaAlgodao,
      ProdutividadePluma: item.produtividadePluma,
      ProducaoPluma: this.calcularProducaoPluma(item),
    };

    var paramsNumeroCertificado = {
      CodigoSafra: item.codigoSafra,
      UnidadeProdutivaId: item.id,
      upCertificacaoId: item.upID,
      numeroCertificadoBCI: item.numeroCertificadoBCI,
    };

    console.log(paramsNumeroCertificado);

    /*
     this.Services.postWithParams('UpCertificacao/AtualizaNumeroCertificacaoBCI', paramsNumeroCertificado)
      .subscribe(res => {
        console.log(res);

      });
      */

    console.log("ANTES");

    this.Services.post(
      "UpCertificacao/AtualizaNumeroCertificacaoBCI",
      paramsNumeroCertificado
    )
      .pipe(
        concatMap((resPluma: any) => {
          var t = resPluma;
          console.log(t); // Isso mostrará o valor retornado pela primeira API

          if (resPluma === "Existe_NumeroBCI") {
            // Use === para comparação estrita
            this.toastService.showToast(
              ToastType.DANGER,
              "Error",
              "Já existe código de fazenda " +
                paramsNumeroCertificado.numeroCertificadoBCI +
                " cadastrado. Corrija antes de salvar."
            );

            // <<-- AQUI ESTÁ A MUDANÇA CRÍTICA PARA ESTE CAMINHO -->>
            // Se o número BCI já existe, você quer parar a cadeia de Observables.
            // Retorne EMPTY para que o subscribe() não receba mais valores e finalize.
            return EMPTY;

            // Alternativa: Se você quiser que essa condição seja tratada como um erro no .subscribe():
            // return throwError(() => new Error('Número BCI já existente.'));
          } else {
            // <<-- AQUI ESTÁ A MUDANÇA CRÍTICA PARA O CAMINHO DE SUCESSO -->>
            // Se não houver erro de BCI existente, continue com a próxima chamada de API.
            // Esta chamada DEVE retornar um Observable.
            return this.Services.post(
              "UpCertificacao/AlterarLicenciamentoBCIPlumas",
              paramsPluma
            );
          }
        })
      )
      .subscribe(
        (res) => {
          // Este bloco só será executado se a segunda API (AlterarLicenciamentoBCIPlumas)
          // for chamada e concluída com sucesso.
          this.toastService.showToast(
            ToastType.SUCCESS,
            "Success",
            "Dados salvos com sucesso."
          );
        },
        (error) => {
          // Este bloco pegará erros reais de HTTP da primeira ou segunda API,
          // ou erros lançados por throwError (se você optou por ele).
          console.error("Erro na cadeia de APIs:", error);
          this.toastService.showToast(
            ToastType.DANGER,
            "Erro",
            "Ocorreu um erro ao salvar os dados."
          );
        }
      );

    /*

     this.Services.post('UpCertificacao/AlterarLicenciamentoBCIPlumas', paramsPluma)

      .pipe(
        concatMap((resPluma: any) => {
          console.log('Primeira API (Plumas) concluída:', resPluma);

          return this.Services.post('UpCertificacao/AtualizaNumeroCertificacaoBCI', paramsNumeroCertificado)
        })
      )

      .subscribe(res => {

        this.toastService.showToast(ToastType.SUCCESS, "Success", 'Dados salvos com sucesso.');
      });

*/

    //return this.Services.post('UpCertificacao/AlterarLicenciamentoBCIPluma',params);

    //this.toastService.showToast(ToastType.SUCCESS, "Success", 'Dados salvos com sucesso.');
  }

  atualizaNumeroCertificacaoBci(): void {
    this.showSpinner();
    let params = this._getSeachParams();

    const safra = this.appService.getSafraSelecionada();

    //this.Services.get(`NotaExplicativa/VerificarExistenciaNotaEx/${unidadadeProdutiva.id}/${safra.id}`);
    this.hideSpinner();

    this.toastService.showToast(
      ToastType.SUCCESS,
      "Success",
      "Dados salvos com sucesso."
    );
  }

  handleChangeSort(field: string, direction: SortDirection) {
    this.sortField = field;
    this.sortDirection = direction;

    this.refreshPage();
  }

  abrirMeusFormularios() {
    console.log("abrir meus formularios");
  }

  buscarUnidadesProdutivas() {
    this.refreshPage();
  }

  // Método que "desformata" o valor digitado pelo usuário
  parseNumber(value: string): number | null {
    if (value === null || value === undefined || value.trim() === "") {
      return null;
    }

    // Remove os pontos de milhar e substitui a vírgula decimal por ponto (se houver)
    // Isso é crucial para que parseFloat entenda o número corretamente.
    const cleanedValue = value.replace(/\./g, "").replace(/,/g, ".");
    const parsed = parseFloat(cleanedValue);

    return isNaN(parsed) ? null : parsed;
  }
}
